import { render } from "./AddBusiness.vue?vue&type=template&id=f074595e&ts=true"
import script from "./AddBusiness.vue?vue&type=script&lang=ts"
export * from "./AddBusiness.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__